// @flow

import { RECEIVED_ASSORTMENT_SETTINGS } from './constants';
import type { State as Payload } from './types';

export type ReceivedAssortmentSettings = {
  type: typeof RECEIVED_ASSORTMENT_SETTINGS,
  payload: Payload,
};

export const receivedAssortmentSettings = (data: Payload): ReceivedAssortmentSettings => ({
  type: RECEIVED_ASSORTMENT_SETTINGS,
  payload: data,
});

export default null;
